module.exports = __webpack_public_path__ + "assets/webgl/LM_3_2.086dfe21.jpg";